import { trigger, transition, query, style, group, animate, state } from '@angular/animations';

export const slideInAnimation =
    trigger('routeAnimations', [
        transition('LandingPage => *', [
            query(':enter, :leave',
                style({ position: 'fixed', width: '100%' }),
                { optional: true }),
            group([
                query(':enter', [
                    style({ transform: 'translateX(-100%)' }),
                    animate('0.5s ease-in-out',
                        style({ transform: 'translateX(0%)' }))
                ], { optional: true }),
                query(':leave', [
                    style({ transform: 'translateX(0%)' }),
                    animate('0.5s ease-in-out',
                        style({ transform: 'translateX(100%)' }))
                ], { optional: true }),
            ])
        ])
    ]);

export const fader =
    trigger('routeAnimations', [
        transition('* <=> *', [
            query(':enter, :leave', [
                style({
                    position: 'absolute',
                    left: 0,
                    width: '100%',
                    opacity: 0,
                    transform: 'scale(1) translateY(0)'
                })
            ], { optional: true }),
            query(':leave', [
                animate('600ms ease',
                    style({
                        opacity: 1,
                        transform: 'scale(0) translateY(100%)'
                    })
                )
            ], { optional: true }),
        ])
    ]);

export const fadeInOut =
    trigger('routeAnimations', [
        transition('* <=> *', [
            query(':enter, :leave', [
                style({
                    position: 'absolute',
                    width: '100%',
                    height: '100%'
                })
            ], { optional: true }),
            query(':enter', [
                style({
                    opacity: 0,
                })
            ], { optional: true }),
            query(':leave', [
                style({ opacity: 1 }),
                animate('0.4s', style({ opacity: 0 }))
            ], { optional: true }),
            query(':enter', [
                style({
                    opacity: 0,
                }),
                animate('0.4s', style({ opacity: 1 }))
            ], { optional: true }),
        ])
    ]);

export const fadeIf =
    trigger('inOutAnimation', [
        transition('* <=> *', [
            query(':enter, :leave', [
                style({
                    position: 'absolute',
                    width: '100%',
                    height: '100%'
                })
            ], { optional: true }),
            query(':enter', [
                style({
                    opacity: 0,
                })
            ], { optional: true }),
            query(':leave', [
                style({ opacity: 1 }),
                animate('0.4s', style({ opacity: 0 }))
            ], { optional: true }),
            query(':enter', [
                style({
                    opacity: 0,
                }),
                animate('0.4s', style({ opacity: 1 }))
            ], { optional: true }),
        ])
    ]);

export const point =
    trigger('move', [
        state('start', style({ transform: 'translateX(0)' })),
        state('end', style({ transform: 'translateX(25%)' })),
        transition('start => end', animate('1s linear')),
        transition('end => start', animate('1s linear'))
    ]);
